export default "__VITE_ASSET__DEF45or2__"